// Module
var code = "<div class=\"row form-row\"> <div class=\"col-xs-12\"> <div class=\"field\"> <label class=\"input-label required\">Payable to</label> <input type=\"text\" placeholder=\"Enter a name\" label=\"Name\" ng-model=\"vm.form.data.method.data.payable_to\" name=\"payable_to\" ui-input required/> </div> </div> </div> ";
// Exports
module.exports = code;